import type { TranslationPlaceholder } from '#layers/i18n/types';

const TRANSLATION_PLACEHOLDER_PREFIX = '$t:';

/**
 * Whether a string is a `$t:` translation placeholder, e.g. `$t:policies.studio_access`
 * or the parameterized `$t:policies.studio_access({"count":1})`.
 *
 * Only a leading prefix counts — a string that merely contains `$t:` is literal content.
 */
export function isTranslationPlaceholder(value: string | undefined | null): value is TranslationPlaceholder {
	return value?.startsWith(TRANSLATION_PLACEHOLDER_PREFIX) ?? false;
}
